import { TFunction } from 'i18next';

// Names in a sentence of the project rooms ("A, B en C"), one helper and one limit for every room, message, tooltip
// and line.

/** The most names a sentence, a tooltip or a line lists; with more, the count and the first ones. */
export const projectMaxNamesInSentence: number = 3;

/** "A, B en C", with the app's own word for "and" in lower case, as it stands in a sentence. One name stays as it is. */
export const joinProjectNames = (names: string[], t: TFunction<string[]>): string => {
  if (names.length <= 1) return names.join('');

  return `${names.slice(0, -1).join(', ')} ${t('translation:General.Words.And').toLowerCase()} ${names[names.length - 1]}`;
};

/** The first names, at most `projectMaxNamesInSentence`, as "A, B en C". */
export const joinProjectFirstNames = (names: string[], t: TFunction<string[]>): string =>
  joinProjectNames(names.slice(0, projectMaxNamesInSentence), t);

/** Names in a sentence, three at most: "A, B en C", or "A, B en 3 andere". */
export const getProjectNamesSentence = (names: string[], t: TFunction<string[]>): string =>
  names.length <= projectMaxNamesInSentence
    ? joinProjectNames(names, t)
    : t('projects:OutcomeInquiry.Flow.Check.NamesMore', {
        names: names.slice(0, projectMaxNamesInSentence - 1).join(', '),
        count: names.length - (projectMaxNamesInSentence - 1),
      });
